// extracted by mini-css-extract-plugin
export default {"row":"IBear1lhTp8GUx2ioCTZ"};